import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Wordcloud from 'highcharts/modules/wordcloud';
Wordcloud(Highcharts);

const WordCloudMap = () => {

   const wordCloudData = [
        { name: 'antihistamine', weight: 3.57 },
        { name: 'prescriptions', weight: 3.57 },
        { name: 'prescribed', weight: 3.57 },
        { name: 'hospitalization', weight: 3.57 },
        { name: 'proactive', weight: 3.57 },
        { name: 'prescription', weight: 3.57 },
        { name: 'prognosis', weight: 3.57 },
        { name: 'cancer', weight: 3.57 },
        { name: 'clinical', weight: 3.57 },
        { name: 'antiretrovirals', weight: 3.57 },
        { name: 'fda', weight: 3.57 },
        { name: 'shotcovid', weight: 3.57 },
        { name: 'levetiracetam', weight: 3.57 },
        { name: 'nephropathy', weight: 3.57 },
        { name: 'gliomasetmelanotide', weight: 3.57 },
        { name: 'therapies', weight: 3.57 },
        { name: 'chemotherapy', weight: 3.57 },
        { name: 'optometrist', weight: 3.57 },
        { name: 'orthopedic', weight: 3.57 },
        { name: 'vaccinations', weight: 3.57 },
        { name: 'clinicians', weight: 3.57 },
        { name: 'psychiatry', weight: 3.57 },
        { name: 'radiology', weight: 3.57 },
        { name: 'cancers', weight: 3.57 },
        { name: 'medications', weight: 3.57 },
        { name: 'prostates', weight: 3.57 },
      ];

    const chartOptions = {
        chart: {
          backgroundColor: 'rgba(0,0,0,0)',
          type: 'wordcloud',
          animation: true,
          style: {
            fontFamily: 'Roboto',
          },
        },
        title: {
          text: undefined,
        },
        tooltip: {
          useHTML: true,
          outside: true,
          stickOnContact: true,
          backgroundColor: 'black',
          borderWidth: 0,
          style: {
            pointerEvents: 'auto',
            color: 'white',
            width: 500,
            height: 100,
          },
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {},
            },
          },
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        series: [
          {
            data: wordCloudData,
            type: 'wordcloud',
          },
        ],
        // navigation: {}
      };
  return (
    <HighchartsReact
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={chartOptions}
        />
  )
}

export default WordCloudMap;